export default __webpack_public_path__ + "static/media/img_placeholder.84b5fd68.svg";